import { SvgIcon, SvgIconProps } from '@material-ui/core';

export default function MagnifierIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 22 22">
      <g fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.375 19.125C15.2075 19.125 19.125 15.2075 19.125 10.375C19.125 5.54251 15.2075 1.625 10.375 1.625C5.54251 1.625 1.625 5.54251 1.625 10.375C1.625 15.2075 5.54251 19.125 10.375 19.125Z"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.375 20.375L16.625 16.625"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.25 14.125H13.5V6C13.5 5.65482 13.2202 5.375 12.875 5.375H7.875C7.52982 5.375 7.25 5.65482 7.25 6V14.125Z"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11 8.5H13.5"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11 11H13.5"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.25 14.125H5.375"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.375 14.125H13.5"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </SvgIcon>
  );
}
